<template>
  <div>
    <div
      v-if="!isRoleExpert"
      class="main-order"
    >
      <div
        class="left-grid"
        :class="{ 'rss-hide': !showRss }"
        :hide_ref="!referralEnable && !userLimitsEnabled"
      >
        <div class="panel1">
          <BriefcaseHorizontal />
        </div>
        <div
          v-if="userLimitsEnabled"
          class="panel2"
        >
          <UserLimits />
        </div>
        <div
          v-if="referralEnable"
          class="card indent panel2"
        >
          <Referral />
        </div>
        <div class="card indent panel3">
          <TransactionsHistory />
        </div>
        <div
          class="card indent panel4"
          :class="{'skip': !hasVotingData}"
        >
          <Orders
            :header-line="true"
            :is-pagination="false"
          />
        </div>
        <div
          v-if="hasVotingData"
          class="card indent panel5"
        >
          <Voting @voting-data="handleVotingData" />
        </div>
        <div
          v-if="false"
          class="card panel6"
        >
          <IncomeChart />
        </div>
        <div
          v-show="hasNewsData"
          class="card indent panel7"
        >
          <News @news-data="handleNewsData" />
        </div>
        <div
          v-if="showRss"
          class="card indent panel8"
        >
          <Rss />
        </div>
      </div>
    </div>

    <!-- ROLE_EXPERT -->
    <div
      v-else
      class="main-order"
    >
      <div
        class="expert-grid"
        :class="{ 'rss-hide': !showRss }"
      >
        <div class="card indent panel4">
          <Projects
            :items-per-page="4"
            :header-line="true"
            :is-pagination="false"
          />
        </div>
        <div class="card indent panel3">
          <EscrowWithdrawal
            :items-per-page="4"
            :header-line="true"
            :is-pagination="false"
          />
        </div>
        <div
          v-show="hasNewsData"
          class="card indent panel7"
        >
          <News />
        </div>
        <div
          v-if="showRss"
          class="card indent panel6"
        >
          <Rss />
        </div>
      </div>
    </div>
    <PopUp />
  </div>
</template>

<script>
import BriefcaseHorizontal from "@/panels/components/BriefcaseHorizontal.vue";
import EscrowWithdrawal from "@/panels/components/EscrowWithdrawal.vue";
import IncomeChart from "@/components/dashboard/IncomeChart.vue";
import isUserRole from "@/help/isUserRole";
import News from "@/components/dashboard/News.vue";
import Orders from "@/panels/components/Orders.vue";
import PopUp from "@/components/dashboard/PopUp.vue";
import Projects from "@/panels/components/Projects.vue";
import Referral from "@/components/dashboard/Referral.vue";
import Rss from "@/components/dashboard/Rss.vue";
import TransactionsHistory from "@/components/dashboard/TransactionsHistory.vue";
import UserLimits from "@/panels/components/UserLimits.vue";
import Voting from "@/components/dashboard/Voting.vue";
import { checkAccess, scope } from "@/help/accessData";
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
    PopUp,
    Rss,
    TransactionsHistory,
    EscrowWithdrawal,
    IncomeChart,
    BriefcaseHorizontal,
    Orders,
    Projects,
    Voting,
    Referral,
    News,
    UserLimits
  },
  data() {
    return {
      hasVotingData: false,
      hasNewsData: false
    };
  },

  computed: {
    ...mapGetters({
      language: "language",
      isTestRole: "profile/isTestRole",
      profile: "profile/profile"
    }),

    gridTemplateAreas() {
      // Десктопная версия
      const desktopRows = [
        "\"p1 p2 p3\"",
        "\"p4 p4 p6\"",
        this.hasVotingData ? "\"p4 p4 p5\"" : "\"p4 p4 p8\"",
        this.hasVotingData ? "\"p7 p7 p5\"" : "\"p7 p7 p8\"",
        "\"p7 p7 p8\""
      ].join("\n");

      // Версия для 1500px
      const mediumRows = [
        "\"p1 p2\"",
        "\"p3 p3\"",
        ...(this.hasVotingData ? ["\"p5 p5\""] : []),
        "\"p4 p4\"",
        "\"p6 p6\"",
        this.hasNewsData ? "\"p7 p8\"" : "\"p8 p8\""
      ].join("\n");

      // Мобильная версия
      const mobileRows = [
        "\"p1\"",
        "\"p2\"",
        "\"p3\"",
        ...(this.hasVotingData ? ["\"p5\""] : []),
        "\"p4\"",
        "\"p6\"",
        ...(this.hasNewsData ? ["\"p7\""] : []),
        "\"p8\""
      ].join("\n");

      return {
        desktop: desktopRows,
        medium: mediumRows,
        mobile: mobileRows
      };
    },

    isIssuer() {
      return isUserRole() === "issuer";
    },

    isRoleExpert() {
      return Object.values(this.profile?.roles).includes("ROLE_EXPERT");
    },

    showRss() {
      return this.language === "en"
        ? process.env.VUE_APP_RSS_EN_URL
        : process.env.VUE_APP_RSS_RU_URL;
    },

    referralEnable() {
      return checkAccess(scope.enableReferralSystem);
    },

    userLimitsEnabled() {
      return !checkAccess(scope.notRwa);
    }
  },
  mounted() {
    if (this.isIssuer) {
      this.$router.push({ name: "issuer" });
    }
  },
  methods: {
    handleVotingData(data) {
      this.hasVotingData = !!data?.length;
    },
    handleNewsData(data) {
      this.hasNewsData = !!data?.length;
    }
  }
};
</script>

<style scoped lang="scss">
.left-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, min-content) auto;
  grid-template-areas: v-bind("gridTemplateAreas.desktop");
  @media screen and (max-width: 1500px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(6, auto);
    grid-template-areas: v-bind("gridTemplateAreas.medium");
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas: v-bind("gridTemplateAreas.mobile");
  }
  &[hide_ref="true"] {
    grid-template-areas:
      "p1 p1 p3"
      "p4 p4 p6"
      "p4 p4 p5"
      "p7 p7 p5"
      "p7 p7 p8";
    @media screen and (max-width: 1500px) {
      grid-template-areas:
        "p1 p1"
        "p3 p3"
        "p5 p5"
        "p4 p4"
        "p6 p6"
        "p7 p8";
    }
    @media screen and (max-width: 900px) {
      grid-template-areas:
        "p1"
        "p3"
        "p5"
        "p4"
        "p6"
        "p7"
        "p8";
    }
  }
}
.expert-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, min-content) auto;
  grid-template-areas:
    "p4 p4 p6"
    "p3 p3 p6"
    "p7 p7 p6";
  @media screen and (max-width: 1500px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(6, auto);
    grid-template-areas:
      "p4 p4"
      "p3 p3"
      "p6 p6"
      "p7 p7";
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "p1"
      "p2"
      "p3"
      "p4"
      "p5"
      "p6"
      "p7"
      "p8";
  }
}
.panel1 {
  grid-area: p1;
}
.panel2 {
  grid-area: p2;
}
.panel3 {
  grid-area: p3;
}
.panel4 {
  grid-area: p4;
  max-height: 450px;
  overflow-y: auto;
  height: min-content;
}
.panel5 {
  grid-area: p5;
  padding: 15px 15px 0 15px;
  // height: min-content;
}
.skip {
  grid-row: span 2;
}
.panel6 {
  grid-area: p6;
  padding: 15px;
  // height: min-content;
}
.panel7 {
  grid-area: p7;
  height: min-content;
}
.panel8 {
  grid-area: p8;
  height: min-content;
}
.indent {
  padding: 15px;
}
.rss-hide {
  @media screen and (max-width: 1500px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "p1 p2"
      "p3 p3"
      "p5 p5"
      "p4 p4"
      "p6 p6"
      "p7 p7";
    &[hide_ref="true"] {
      grid-template-areas:
        "p1 p1"
        "p3 p3"
        "p5 p5"
        "p4 p4"
        "p6 p6"
        "p7 p7";
    }
  }
}
</style>
